import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class InsuranceProcessService {
  constructor(private http: HttpClientService) {}

  getInsuranceProcesses(filter) {
    filter = this.removeNullProperties(filter);
    const options = { params: filter };
    return this.http
      .get("/api/insurance_reviews", options)
      .pipe(tap((_) => console.log("InsuranceProcessService.getInsuranceProcesses: Ok.")));
  }

  public show(id): Observable<any> {
    return this.http
      .get("/api/insurance_reviews/" + id)
      .pipe(tap((_) => console.log("InsuranceProcessService.show: Ok")));
  }

  public getQuoteSummary(id: number | string): Observable<any> {
    return this.http
      .get(`/api/insurance_reviews/${id}/quote_summary`)
      .pipe(tap((_) => console.log("InsuranceProcessService.getQuoteSummary: Ok.")));
  }

  public workflowAction(id: number | string, action: string, options?: any): Observable<any> {
    const params = {
      flux_action: action,
      options: options || {},
    };
    return this.http
      .post("/api/insurance_reviews/" + id + "/workflow_action", params)
      .pipe(tap((_) => console.log("InsuranceProcessService.workflowAction: Ok.")));
  }

  removeNullProperties(obj) {
    for (let prop in obj) {
      if (obj[prop] === null) {
        delete obj[prop];
      }
    }
    return obj;
  }
}
